import { required, minLength } from "vuelidate/lib/validators";
import { telephone, cnpj, cpf } from "./validators";
import { Model } from "./Model";
import { Cnae, CnaeValidation } from "./Cnae";
import { Tipo, TipoValidation, TipoNoValidation } from "./Tipo";
import { Contato, ContatoValidation, ContatoNoValidation } from "./Contato";
// import { Municipio, MunicipioValidation, MunicipioNoValidation } from './Municipio'
import { Regime, RegimeValidation, RegimeNoValidation } from "./Regime";
import { Contabilista } from "./Contabilista";
import { Endereco, EnderecoValidation, EnderecoNoValidation } from "./Endereco";

class Empresa extends Model {
  constructor() {
    super();
    this.cnpj = "";
    this.filialDe = 0;
    this.fantasia = "";
    this.razaoSocial = "";
    this.emails = [];
    this.telefone = "";
    this.telefone2 = "";
    this.celular = "";
    this.ie = "";
    this.im = "";
    this.analise = false;
    this.cei = "";
    this.cnae = new Cnae();
    this.tipo = new Tipo();
    this.contato = new Contato();
    this.senhaContribuinte = "";
    this.csc = "";
    this.numeroCsc = "";
    // this.municipio = new Municipio()
    this.endereco = new Endereco();
    this.ativo = true;
    this.regime = new Regime();
    this.contabilista = new Contabilista();
    this.pacoteContabilidade = true;
    this.obs = "";
    this.dtCadastro = "";
    this.dtCompetencia = "";
    this.obrigacoes = [];
    this.layoutLivroEntrada = "NovoLivroEntradaDominio";
    this.nfce = false;
    this.nfse = false;
    this.nire = "";
    this.isenta = false;
    this.site = false;
    this.unidadesConsumidoras = [];
    this.rubricas = [];
    this.idSistemaFolha = 0;
  }
}

const EmpresaValidation = function () {
  return {
    true: {
      isenta: {},
      cnpj: {
        required,
        cnpj,
      },
      fantasia: { required },
      razaoSocial: { required },
      emails: {},
      telefone: {},
      celular: {},
      // ie: {
      //   ie: {}
      // },
      nire: {},
      im: {},
      cnae: CnaeValidation,
      tipo: TipoValidation,
      contato: ContatoNoValidation,
      // senhaContribuinte: {
      //   senhaContribuinte: {}
      // },
      // municipio: MunicipioValidation,
      endereco: EnderecoNoValidation,
      regime: RegimeValidation,
      contabilista: {
        nome: {},
        tipo: {
          descricao: {},
        },
      },
      dtCompetencia: {},
      obrigacoes: {},
    },
    false: {
      isenta: {},
      cnpj: {
        required,
        cnpj,
      },
      fantasia: { required },
      razaoSocial: { required },
      emails: {},
      telefone: {
        required,
        telephone,
      },
      celular: {
        required,
        telephone,
      },
      // ie: {
      //   ie: function (vl) {
      //     return this.empresa.isenta || !!vl.length
      //   }
      // },
      nire: {},
      im: { required },
      cnae: CnaeValidation,
      tipo: TipoValidation,
      contato: ContatoValidation,
      // senhaContribuinte: {
      //   senhaContribuinte: function (vl) {
      //     return this.empresa.isenta || !!vl.length
      //   }
      // },
      // municipio: MunicipioValidation,
      endereco: EnderecoValidation,
      regime: RegimeValidation,
      contabilista: {
        nome: { required },
        tipo: {
          descricao: { required },
        },
      },
      dtCompetencia: { required },
      obrigacoes: {
        required,
        minLength: minLength(1),
      },
    },
  };
};

const EmpresaNewValidation = function () {
  return {
    isenta: {},
    cnpj: {
      required,
      cnpj,
    },
    fantasia: {},
    razaoSocial: { required },
    emails: {},
    telefone: {
      telephone,
    },
    celular: {
      telephone,
    },
    cnae: CnaeValidation,
    endereco: EnderecoValidation,
    dtCompetencia: {},
  };
};

const EmpresaPessoaFisicaValidation = {
  true: {
    cnpj: {
      required,
      cnpj(value) {
        return cpf(value);
      },
    },
    fantasia: { required },
    razaoSocial: { required },
    emails: {},
    telefone: {},
    celular: {},
    ie: { required },
    cei: {},
    im: {},
    cnae: CnaeValidation,
    tipo: TipoValidation,
    contato: ContatoNoValidation,
    senhaContribuinte: {
      senhaContribuinte: {},
    },
    // municipio: MunicipioValidation,
    endereco: EnderecoNoValidation,
    regime: RegimeValidation,
    contabilista: {
      nome: {},
      tipo: {
        descricao: {},
      },
    },
    dtCompetencia: {},
    obrigacoes: {},
  },
  false: {
    cnpj: {
      required,
      cnpj(value) {
        return cpf(value);
      },
    },
    fantasia: { required },
    razaoSocial: { required },
    emails: {},
    telefone: {
      required,
      telephone,
    },
    celular: {
      required,
      telephone,
    },
    ie: { required },
    cei: {},
    im: {},
    cnae: CnaeValidation,
    tipo: TipoValidation,
    contato: ContatoValidation,
    senhaContribuinte: {
      senhaContribuinte: {},
    },
    // municipio: MunicipioValidation,
    endereco: EnderecoValidation,
    regime: RegimeValidation,
    contabilista: {
      nome: { required },
      tipo: {
        descricao: { required },
      },
    },
    dtCompetencia: { required },
    obrigacoes: {
      required,
      minLength: minLength(1),
    },
  },
};

const EmpresaNoValidation = {
  cnpj: {
    required,
    cnpj,
  },
  fantasia: { required },
  razaoSocial: { required },
  emails: {},
  telefone: {},
  celular: {},
  ie: {
    ie: () => true,
  },
  im: {},
  cnae: {},
  tipo: TipoNoValidation,
  contato: ContatoNoValidation,
  senhaContribuinte: {
    senhaContribuinte: {},
  },
  // municipio: MunicipioNoValidation,
  endereco: EnderecoNoValidation,
  regime: RegimeNoValidation,
  contabilista: {
    nome: {},
    tipo: {
      descricao: {},
    },
  },
  dtCompetencia: {},
  obrigacoes: {},
};

const FieldNames = {
  cnpj: {
    name: "CPF/CNPJ",
    description: "Aba Dados da Empresa -> CNPJ",
    type: "CRITICAL",
  },
  fantasia: {
    name: "Fantasia",
    description: "Aba Dados da Empresa -> Fantasia",
    type: "CRITICAL",
  },
  razaoSocial: {
    name: "Razão Social",
    description: "Aba Dados da Empresa -> Razão Social",
    type: "CRITICAL",
  },
  emails: { name: "Emails", description: "Aba Dados da Empresa -> Emails" },
  telefone: {
    name: "Telefone",
    description: "Aba Dados da Empresa -> Telefone",
  },
  celular: { name: "Celular", description: "Aba Dados da Empresa -> Celular" },
  ie: { name: "IE", description: "Aba Dados da Empresa -> IE" },
  im: {
    name: "Inscrição Municipal",
    description: "Aba Dados da Empresa -> Insc. Municipal",
    type: "CRITICAL",
  },
  cnae: {
    name: "CNAE Fiscal",
    description: "Aba Dados da Empresa -> CNAE Fiscal",
    type: "CRITICAL",
  },
  tipo: {
    name: "Tipo Empresa",
    description: "Aba Dados da Empresa -> Tipo Empresa",
  },
  contato: { name: "Dados do responsável", description: "Aba Responsável" },
  senhaContribuinte: {
    name: "Senha Contribuinte",
    description: "Aba Dados da Empresa -> Senha Contribuinte",
    type: "CRITICAL",
  },
  // municipio: { name: 'Município', description: 'Aba Dados da Empresa -> Município', type: 'CRITICAL' },
  endereco: { name: "Endereço", description: "Aba endereço", type: "CRITICAL" },
  regime: {
    name: "Regimes Tributários",
    description: "Aba Regimes Tributários",
    type: "CRITICAL",
  },
  contabilista: {
    name: "Contabilista",
    description: "Aba Dados da Empresa -> Contabilista",
    type: "CRITICAL",
  },
  dtCompetencia: {
    name: "Início da Atividade",
    description: "Aba Dados da Empresa -> Início da Atividade",
  },
  obrigacoes: {
    name: "Obrigações",
    description: "Aba Dados da Empresa -> Obrigações",
  },
};

const CriticalFields = [
  "cnpj",
  "razaoSocial",
  "fantasia",
  "ie",
  "im",
  "municipio",
  "endereco",
  "cnae",
  "senhaContribuinte",
  "contabilista",
  "regime",
];

export {
  Empresa,
  EmpresaValidation,
  FieldNames,
  CriticalFields,
  EmpresaNoValidation,
  EmpresaPessoaFisicaValidation,
  EmpresaNewValidation,
};
